import Api from '@/api'


const fetchAll = () => {	
    return Api.get('api/treatments')
};

const postForm =  (payload,id) => {  
    
    if(typeof id != "undefined") { 
        
        return Api.put('api/treatments/' + id , payload)       
    } else {
        return Api.post('api/treatments' , payload)       
    }
    
};

const getById =  (payload) => {        
    return Api.get('api/treatments/' + payload)       
};

const deleteById =  (payload) => {        
    return Api.delete('api/treatments/'+payload)
    
};

export default {
  fetchAll,
  postForm,
  getById,
  deleteById
};